module.exports = __webpack_public_path__ + "static/woman-yellow-sweater.d325bbdf.jpg";